import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface ControlPanelKPI {
  published_producers: number;
  active_events: number;
  bookings_30d: number;
  needs_action: number;
}

export interface ControlPanelFunnel {
  interest_sent: number;
  accepted: number;
  linked_place: number;
  published: number;
  has_activity: number;
  has_booking: number;
}

export interface ControlPanelBlockers {
  missing_category: number;
  missing_activity: number;
  missing_image: number;
  missing_place: number;
  ready_to_publish: number;
}

export interface ControlPanelStagnated {
  public_no_activity: number;
  activity_no_booking: number;
  inactive_60d: number;
}

export interface ControlPanelData {
  kpi: ControlPanelKPI;
  funnel: ControlPanelFunnel;
  blockers: ControlPanelBlockers;
  stagnated: ControlPanelStagnated;
}

export function useAdminControlPanel() {
  return useQuery({
    queryKey: ['admin-control-panel'],
    queryFn: async (): Promise<ControlPanelData> => {
      const { data, error } = await supabase.rpc('admin_control_panel_stats' as any);
      if (error) throw error;
      return data as unknown as ControlPanelData;
    },
    staleTime: 60_000,
  });
}
